<template>
  <div class="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-8 gap-3">
    <KpiTile label="Scheduled" :metric="k.scheduled" :loading="loading" :dot-color="PALETTE.blue"
      definition="Bookings taken during this period. Excludes the superseded half of a reschedule and bookings whose payment was rejected, so one meeting is never counted twice." />
    <KpiTile label="Completed" :metric="k.completed" :loading="loading" :dot-color="PALETTE.green"
      definition="Meetings that finished inside this period and were still confirmed when they did. A confirmed meeting still in the future is not counted." />
    <KpiTile label="Canceled" :metric="k.canceled" :loading="loading" :dot-color="PALETTE.red" :higher-is-better="false"
      definition="Bookings canceled during this period, counted on the day of the cancellation rather than the day the booking was made." />
    <KpiTile label="Rescheduled" :metric="k.rescheduled" :loading="loading" :dot-color="PALETTE.amber" :higher-is-better="false"
      definition="Meetings moved during this period, counted on the day of the move." />
    <KpiTile label="Cancellation rate" :metric="k.cancellation_rate" format="percent" :loading="loading"
      :dot-color="PALETTE.red" :higher-is-better="false"
      definition="Of the meetings due to start in this period, the share that were canceled." />
    <KpiTile label="Median notice" :metric="k.median_lead_hours" format="duration" :loading="loading"
      :dot-color="PALETTE.violet"
      definition="The typical gap between someone booking and the meeting starting. Median rather than average, so one meeting booked a year out cannot distort it." />
    <KpiTile label="People" :metric="k.unique_attendees" :loading="loading" :dot-color="PALETTE.cyan"
      definition="Distinct attendees across the bookings taken in this period. Someone who books three times counts once." />
    <KpiTile label="Hours met" :metric="k.booked_hours" format="hours" :loading="loading" :dot-color="PALETTE.pink"
      definition="Total scheduled length of the meetings that completed in this period." />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import KpiTile from '../shared/KpiTile.vue'
import { PALETTE } from '../shared/useAnalyticsChart.js'

const props = defineProps({
  kpis:    { type: Object, default: null },
  loading: { type: Boolean, default: false },
})

// Empty tiles rather than undefined while the first request is open, so the
// row keeps its shape instead of collapsing and reflowing the page under it.
const k = computed(() => props.kpis || {})
</script>
